export enum LinkedItemsTypeEnum {
	INVOICE_NFE = "INVOICE_NFE",
	INVOICE_RENTAL = "INVOICE_RENTAL",
	SALES_ORDER = "SALES_ORDER",
	SERVICE_ORDER = "SERVICE_ORDER",
	INVOICE_NFSE = "INVOICE_NFSE"
}
